import { lazy } from "react";
import Loadable from "../../components/Loadable";

const ChatMain = Loadable(lazy(() => import("./ChatMain")));

const chatRoute = [
  {
    path: "/chat",
    element: <ChatMain />,
    permission: null, // All authenticated users can access chat
  },
];

export default chatRoute;


